import http from '../../../services/http'

export default {
    getFolders: () => http.get('folders'),
    create: (d) => http.post('folders', d),
    update: (id, d) => http.put('folders/' + id, d),
    delete: (id) => http.delete('folders/' + id),
}